import { call, put, takeLatest } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import * as ApiRoute from 'constants/apiRouting'
import NoticeHelper from 'helpers/notice'
import UrlHelper from 'helpers/url'
import { SHOW_NOTICE } from '../notice'
import {
  SET_LOOKUP_TABLES_IS_LOADING,
  FAILURE_FETCH_LOOKUP_TABLES_DATA,
  SUCCESS_FETCH_LOOKUP_TABLES_DATA,
  FETCH_LOOKUP_TABLES_DATA,
  CREATE_LOOKUP_TABLE,
  DELETE_LOOKUP_TABLE,
  UPDATE_LOOKUP_TABLE,
  LOOKUP_TABLE_ACTION,
  FETCH_LOOKUP_TABLES_TABLE_DATA,
  FETCH_LOOKUP_TABLES_TABLE_INFO,
  SUCCESS_FETCH_LOOKUP_TABLES_TABLE_DATA,
  FAILURE_FETCH_LOOKUP_TABLES_TABLE_DATA,
  SUCCESS_FETCH_LOOKUP_TABLES_TABLE_INFO,
  FAILURE_FETCH_LOOKUP_TABLES_TABLE_INFO,
  CREATE_LOOKUP_TABLE_DATA_ENTRY,
  UPDATE_LOOKUP_TABLE_ROW,
  DELETE_LOOKUP_TABLES_TABLE_DATA,
  SUCCESS_LOOKUP_TABLES_FILTERS,
  FAILURE_LOOKUP_TABLES_FILTERS,
  FETCH_LOOKUP_TABLES_FILTERS,
} from './reducer'

function* fetchLookupTablesData({ payload: { psfs } }) {
  try {
    yield put({ type: SET_LOOKUP_TABLES_IS_LOADING, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRoute.LOOKUP_TABLES_TABLE}${UrlHelper.getPsfsQuery({
        psfs,
      })}`,
    })

    if (response && !response.error) {
      yield put({ type: SUCCESS_FETCH_LOOKUP_TABLES_DATA, payload: response })
    } else {
      yield put({ type: FAILURE_FETCH_LOOKUP_TABLES_DATA })
    }

    yield put({ type: SET_LOOKUP_TABLES_IS_LOADING, payload: false })
  } catch (error) {
    console.error('FETCH LOOKUP TABLES DATA FAILED:', error)
  }
}

function* createLookupTable({
  payload: { data, successMessage, errorMessage },
  promise,
}) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.LOOKUP_TABLES,
      method: 'POST',
      data,
    })

    if (response && !response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(successMessage),
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(errorMessage),
      })
    }

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }
  } catch (error) {
    console.log('CREATE LOOKUP TABLE ERROR', error)
  }
}

function* deleteLookupTable({
  payload: { id, successMessage, errorMessage },
  promise,
}) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRoute.LOOKUP_TABLES}/${id}`,
      method: 'DELETE',
    })

    if (response && !response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(successMessage),
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(errorMessage),
      })
    }

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }
  } catch (error) {
    console.log('DELETE LOOKUP TABLE ERROR', error)
  }
}

function* updateLookupTable({
  payload: { id, data, successMessage, errorMessage },
  promise,
}) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRoute.LOOKUP_TABLES}/${id}`,
      method: 'PUT',
      data,
    })

    if (response && !response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(successMessage),
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(errorMessage),
      })
    }

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }
  } catch (error) {
    console.log('DELETE LOOKUP TABLE ERROR', error)
  }
}

function* updateLookupTableRow({
  payload: { tableId, rowId, data, successMessage, errorMessage },
  promise,
}) {
  yield put({ type: SET_LOOKUP_TABLES_IS_LOADING, payload: true })

  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(ApiRoute.LOOKUP_TABLE_DATA, {
        id: tableId,
      })}/${rowId}`,
      method: 'PUT',
      data,
    })

    if (response && !response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(successMessage),
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(errorMessage),
      })
    }

    yield put({ type: SET_LOOKUP_TABLES_IS_LOADING, payload: false })

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }
  } catch (error) {
    console.log('UPDATE LOOKUP TABLE ERROR', error)
  }
}

function* lookupTableAction({
  payload: { id, action, successMessage, errorMessage },
  promise,
}) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRoute.LOOKUP_TABLES}/${id}/${action}`,
      method: 'PUT',
    })

    if (response && !response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(successMessage),
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(errorMessage),
      })
    }

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }
  } catch (error) {
    console.log('LOOKUP TABLE ACTION ERROR', error)
  }
}

function* fetchLookupTablesTableInfo({ payload: { id }, promise }) {
  try {
    yield put({ type: SET_LOOKUP_TABLES_IS_LOADING, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRoute.LOOKUP_TABLES}/${id}`,
    })

    if (response && !response.error) {
      yield put({
        type: SUCCESS_FETCH_LOOKUP_TABLES_TABLE_INFO,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_FETCH_LOOKUP_TABLES_TABLE_INFO })
    }

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }

    yield put({ type: SET_LOOKUP_TABLES_IS_LOADING, payload: false })
  } catch (error) {
    console.error('FETCH LOOKUP TABLES INFO FAILED:', error)
  }
}

function* fetchLookupTablesTableData({ payload: { id, psfs } }) {
  try {
    yield put({ type: SET_LOOKUP_TABLES_IS_LOADING, payload: true })
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(ApiRoute.LOOKUP_TABLE_DATA_TABLE, {
        id,
      })}${UrlHelper.getPsfsQuery({ psfs })}`,
    })

    if (response && !response.error) {
      yield put({
        type: SUCCESS_FETCH_LOOKUP_TABLES_TABLE_DATA,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_FETCH_LOOKUP_TABLES_TABLE_DATA })
    }

    yield put({ type: SET_LOOKUP_TABLES_IS_LOADING, payload: false })
  } catch (error) {
    console.error('FETCH LOOKUP TABLES TABLE DATA FAILED:', error)
  }
}

function* createLookupTableDataEntry({
  payload: { data, id, successMessage, errorMessage },
  promise,
}) {
  try {
    yield put({ type: SET_LOOKUP_TABLES_IS_LOADING, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.LOOKUP_TABLE_DATA, { id }),
      method: 'POST',
      data,
    })

    if (response && !response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(successMessage),
      })
    } else if (response && response.status === 400) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(response.errors.content),
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(errorMessage),
      })
    }

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }

    yield put({ type: SET_LOOKUP_TABLES_IS_LOADING, payload: false })
  } catch (error) {
    console.log('CREATE LOOKUP TABLE DATA ENTRY ERROR', error)
  }
}

function* deleteLookupTablesTableData({
  payload: { id, data, successMessage, errorMessage },
  promise,
}) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.LOOKUP_TABLE_DATA_BATCH, { id }),
      method: 'DELETE',
      data,
    })

    if (response && !response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(successMessage),
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(errorMessage),
      })
    }

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }
  } catch (error) {
    console.error('DELETE LOOKUP TABLES TABLE DATA FAILED:', error)
  }
}

function* fetchLookupTablesFilters() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRoute.LOOKUP_TABLES_FILTERS}`,
    })

    if (response && !response.error) {
      yield put({ type: SUCCESS_LOOKUP_TABLES_FILTERS, payload: response })
    } else {
      yield put({ type: FAILURE_LOOKUP_TABLES_FILTERS })
    }
  } catch (error) {
    console.error('FETCH LOOKUP TABLES FILTERS LIST FAILED:', error)
  }
}

function* lookupTablesSaga() {
  yield takeLatest(FETCH_LOOKUP_TABLES_DATA, fetchLookupTablesData)
  yield takeLatest(CREATE_LOOKUP_TABLE, createLookupTable)
  yield takeLatest(DELETE_LOOKUP_TABLE, deleteLookupTable)
  yield takeLatest(UPDATE_LOOKUP_TABLE, updateLookupTable)
  yield takeLatest(UPDATE_LOOKUP_TABLE_ROW, updateLookupTableRow)
  yield takeLatest(LOOKUP_TABLE_ACTION, lookupTableAction)
  yield takeLatest(FETCH_LOOKUP_TABLES_TABLE_DATA, fetchLookupTablesTableData)
  yield takeLatest(FETCH_LOOKUP_TABLES_TABLE_INFO, fetchLookupTablesTableInfo)
  yield takeLatest(CREATE_LOOKUP_TABLE_DATA_ENTRY, createLookupTableDataEntry)
  yield takeLatest(DELETE_LOOKUP_TABLES_TABLE_DATA, deleteLookupTablesTableData)
  yield takeLatest(FETCH_LOOKUP_TABLES_FILTERS, fetchLookupTablesFilters)
}

export default lookupTablesSaga
